<template>
    <div class="post-img">
        <h2 style="margin: 70px 0 30px 25px;">{{ mainHeadline }}</h2>
        <router-link :to="`${$route.params.locale ? `/${$route.params.locale}` : ''}/edit-page/${mid}/${id}`" class="btn btn-brown" v-if="auth ? (auth.pages.edit) : false">{{ t('edit') }}</router-link>
    </div>

    <div class="post-content">
        <!-- <div class="right">
            <h1 class="main-headline" v-text="mainHeadline"></h1>
            <p v-html="parseContentToHTML"></p>
        </div> -->
        <div v-html="parseContentToHTML"></div>
    </div>
</template>

<script setup>

import $ from 'jquery'
import { computed } from 'vue'
import { QuillDeltaToHtmlConverter } from 'quill-delta-to-html'; 
import { useAuth } from '@/authentication'
import { useI18n } from 'vue-i18n'
import { useRoute } from 'vue-router'

const VUE_APP_SERVER_ROOT = process.env.VUE_APP_SERVER_ROOT
const props = defineProps([ "mainHeadline", "content", "mid", "id" ])
const auth = useAuth()
const { t } = useI18n()
const $route = useRoute()

function checkExpressionStyles(expr) {
    const insert = expr.insert, attribs = expr.attributes ?? {}

    var classList = [],
        tag = "span",
        additionalAttributes = []

    if (attribs.bold) classList[classList.length] = "bold"
    if (attribs.italic) classList[classList.length] = "italic"

    if (attribs.link) {
        tag = "a"
        additionalAttributes[additionalAttributes.length] = `href="${attribs.link}"`
    }

    return `<${tag} class="${classList.join(" ")}" ${additionalAttributes.join(" ")}>${insert}</${tag}>`
}

/* const parseContentToHTML = computed(() => {
    const content = props.content
    var result = ""
    var oneLine = "%{0}"
    var onList = false

    for (const key in content) {
        if (Object.hasOwnProperty.call(content, key)) {
            const 
                item = content[key],
                insert = item.insert,
                attribs = item.attributes ?? {}

            if (insert == "\n") {
                if (!onList) {
                    if (attribs.list) {
                        onList = attribs.list
                        result += `<${onList == 'bullet' ? 'ul' : "ol"}>`
                    } else {
                        // Nothing To Do
                    }
                } else {
                    if (attribs.list) {
                        if (attribs.list == onList) {
                            // Nothing To Do
                        } else {
                            result += `</${onList == 'bullet' ? 'ul' : "ol"}>`
                            onList = attribs.list
                            result += `<${onList == 'bullet' ? 'ul' : "ol"}>`
                        }
                    } else {
                        result += `</${onList == 'bullet' ? 'ul' : "ol"}>`
                        onList = false
                    }
                }
            }

            if (!insert.hasOwnProperty("image")) {
                var splitByNewLineChar = insert.split("\n"),
                tag = "p"

                if (Object.getOwnPropertyNames(content).indexOf(key) == 0 && onList) {
                    tag = "li"
                } 

                if (splitByNewLineChar.length > 1) {
                    const newLine = "%{0}" + splitByNewLineChar.pop()
                    oneLine += splitByNewLineChar.join("\n") + "%{1}"
                    
                    if (attribs.header) {
                        tag = `h${attribs.header}`
                    }
                    if (onList) {
                        tag = 'li'
                    }

                    result += oneLine.format(`<${tag}>`, `</${tag}>`)

                    oneLine = newLine
                } else {
                    oneLine += checkExpressionStyles(item)
                }

            } else {
                result += "<img src='" + insert.image + "' class='inter-text-img' />"
            }

        }
    }

    return result

}) */

const parseContentToHTML = computed(() => {
    const config = {}

    const converter = new QuillDeltaToHtmlConverter(props.content, config)

    return converter.convert();
})

</script>